import React from 'react'
import {Component} from 'react'
import {ReactSVG} from 'react-svg'
import {isMobile, isIPad} from "../../Platform";
import {getMe} from '../../Me'

import './index.css'

const me = getMe();

export class Title extends Component { 
    
    constructor (props) {
        super(props)
        this.state = {open: false};
    }
    
    navMenu = () => {
        this.setState({open: !this.state.open});
    }

    navButtonClicked = (location) => {
        this.page = location;
        this.props.navClicked(this.page);
        this.setState({open: !this.state.open});
    }

    navUI = () => {
        if(!isMobile()) {
            return (
                <div className='nanoNavButtons'>
                   {me.getProjectLinks().map((lnk, i) => {
                        return (<div key={i} className='navLink'><button className="nanoButton" onClick={()=>this.navButtonClicked(lnk.code)}>{lnk.name}</button></div>); 
                    })}
                </div>
            );
        } else {
            return (
                <div className='nanoNavMenu'>
                    <button className='nanoNavMenuContent' onClick={()=>this.navMenu()}>
                        <ReactSVG src={this.state.open ? me.getClose() : me.getMenu()} />
                    </button>
                </div>
            );
        }
    }

    render() {
        if (this.page === undefined) {this.page = 'HOME'}
        
        return(
            <div className='nanoStrip'>
                <div className='nanoTitle'>
                    <a className='nanoTitleHREF' onClick={() => {window.location.reload()}}>
                        <div className='nanoLogo'>
                            <div className="nanoLogoMark">
                                <ReactSVG src={me.getBNLogo()} />
                            </div>
                            <div className='nanoLogoText'>BADNANO</div>
                        </div>
                    </a>
                    {this.navUI()}
                </div>
                {(isMobile() && this.state.open) ? 
                    <div className="nanoMenuItems">
                        {me.getProjectLinksMobile().map((lnk, i) => {
                            return (
                            <div key={i} className={(this.page === lnk.code) ? 'navLinkActive' : 'navLink'}>
                                <button className="nanoButton" onClick={()=>this.navButtonClicked(lnk.code)}>{lnk.name}</button>
                                <div className='navLinkArrow'>{(this.page !== lnk.code) ? <ReactSVG src={me.getArrow()} /> : ''}</div>
                            </div>); 
                        })}
                    </div>
                : '' }
            </div>
        );
    }


    componentDidMount() {
        // dom node created
    }

    componentWillUnmount () {
        // dom node deleted
    }

    componentDidUpdate(previousProps, previousState) {
        
    }
}

Title.defaultProps = {
    title: "nanoTitle"
}
